(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-board-card"] && !Shopify.designMode) return;
  try {
    
// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll("form[action='/cart/add']").forEach(form => {
//     form.addEventListener("submit", async (event) => {
//       event.preventDefault();

//       const formData = new FormData(form);

//       console.log("🔥 BYB Debug: Adding variant", formData.get("id"));

//       const response = await fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Accept": "application/json" },
//         body: formData
//       });

//       if (!response.ok) {
//         console.error("BYB Error adding to cart");
//         return;
//       }

//       console.log("🔥 BYB Debug: Item added — opening drawer");
//       window.dispatchEvent(new Event("fluco:modal:cartDrawer:open"));

//       // 🔥 1) FETCH UPDATED CART DRAWER SECTION HTML
//       console.log("🔥 BYB Debug: Fetching updated cart-drawer section...");
//       const sectionResponse = await fetch("/?sections=cart-drawer");
//       const sectionJSON = await sectionResponse.json();

//       const newHTML = sectionJSON["cart-drawer"];
//       if (!newHTML) {
//         console.error("❌ Could not fetch cart-drawer section");
//         return;
//       }

//       // 🔥 2) REPLACE ENTIRE <cart-drawer> ELEMENT
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(newHTML, "text/html");
//       const newDrawer = doc.querySelector("cart-drawer");
//       const oldDrawer = document.querySelector("cart-drawer");

//       if (!newDrawer || !oldDrawer) {
//         console.error("❌ Drawer element missing, reloading.");
//         //window.location.reload();
//         return;
//       }

//       console.log("🔥 BYB Debug: Replacing <cart-drawer> with fresh HTML");
//       oldDrawer.replaceWith(newDrawer);

//       // 🔥 3) REOPEN DRAWER (the element was replaced!)
//       window.dispatchEvent(new Event("fluco:modal:cartDrawer:open"));

//       console.log("🔥 BYB Debug: Drawer updated SUCCESSFULLY");
//       console.log("🔥 BYB Debug: Fetching updated HEADER section…");

//       const headerResponse = await fetch("/?sections=header");
//       const headerJSON = await headerResponse.json();

//       if (headerJSON["header"]) {
//         const parser2 = new DOMParser();
//         const doc2 = parser2.parseFromString(headerJSON["header"], "text/html");

//         const newHeader = doc2.querySelector("header");
//         const oldHeader = document.querySelector("header");

//         if (newHeader && oldHeader) {
//           console.log("🔥 BYB Debug: Replacing <header> with fresh HTML");
//           oldHeader.replaceWith(newHeader);
//         } else {
//           console.warn("⚠️ BYB Warning: Header component not found — maybe different section name");
//         }
//       }
//     });
//   });
// });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["build-your-board-double"] && !Shopify.designMode) return;
  try {
    
// Optional hook
document.addEventListener('DOMContentLoaded', function(){});

  } catch(e) { console.error(e); }
})();
})();
